import Page from 'pages/Page';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import {
  importMediaMobileChunks,
  importMediaDesktopChunks,
  importMediaPopinChunks,
  importReviewsChunks,
  importSidebarChunks,
  importAddToCartChunks,
  importAlertChunks,
  importInformationChunks,
  importScrollToTopChunks,
  importTrackingProductChunks,
  importCtaStickyChunks,
} from '../../components/Product/Chunks/Chunks';
import MediaQueries from '../../shared/helpers/MediaQueries';
import WishlistChunk from '../../modules/InitChunks/WishlistChunk/WishlistChunk';

export default class Product extends Page {
  constructor() {
    super();

    /*
     * Primary script.
     * */
    window.addEventListener(
      'load',
      () => {
        // Load CTA Sticky
        if (MediaQueries.mobileMedia.matches) {
          importCtaStickyChunks();
        }

        // Tracking Algolia
        importTrackingProductChunks();

        // Breadcrumb
        new Breadcrumb();

        // Slider medias Mobile
        importMediaMobileChunks();

        // Slider medias Desktop
        importMediaDesktopChunks();

        // Add to cart
        importAddToCartChunks();

        // Alert
        importAlertChunks();

        // Add Wishlist
        WishlistChunk();
      },
      { once: true, passive: true }
    );

    /*
     * Secondary script
     * */
    if (MediaQueries.mobileMedia.matches) {
      // Load files for Mobile
      document.addEventListener(
        'touchstart',
        () => {
          this.importsChunks();
        },
        { once: true, passive: true }
      );
    } else {
      // Load files for other
      this.importsChunks();
    }
  }

  private importsChunks(): void {
    // Popin
    importMediaPopinChunks();
    // Information
    importInformationChunks();
    // Sidebar
    importSidebarChunks();
    // Scroll To Top
    importScrollToTopChunks();
    // Reviews
    importReviewsChunks();
  }
}

new Product();
